export class Brand {
  public id: string;
  public name: string;
  public isDefault: boolean;
  public logoUrl: string;

  constructor(init?: Partial<Brand>) {
    Object.assign(this, init);
  }
}
